<template>
  <div>
    <h2 class="text-left alert" :class="[removed ? 'alert-danger' : 'alert-success']">
      This season Dry-off
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[removed ? 'glyphicon-plus' : 'glyphicon-remove']"></span>
      </a>
    </h2>

    <template v-if="!removed">
      <report-comment field_name="heading_this_season_dryoff" :model="model.COMMENTS" :heading="true"> </report-comment>
      <subsection
        :title="`This season Dry-off ${farm.farm_label}`"
        :step-name="stepName"
        :subsection="`farm_${farm.id}-this_season_dryoff`"
        v-for="farm in model.FARMS"
        :key="`farm_${farm.id}-this_season_dryoff`"
      >
        <dl class="dl-horizontal">
          <dt>Cows</dt>
          <dd>{{ model[`farm_${farm.id}-cows_at_dryoff`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Heifers</dt>
          <dd>{{ model[`farm_${farm.id}-heifers_at_dryoff`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Earliest dry-off date</dt>
          <dd>{{ model[`farm_${farm.id}-earliset_dryoff_date`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Latest dry-off date</dt>
          <dd>{{ model[`farm_${farm.id}-latest_dryoff_date`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Earliest calving date (MA cows)</dt>
          <dd>{{ model[`farm_${farm.id}-earliest_calving_date`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Min dry-off length (calculated)</dt>
          <dd>{{ model[`farm_${farm.id}-min_dryoff_days_calc`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Dry off location</dt>
          <dd>{{ model[`farm_${farm.id}-dryoff_location`] || '-' }}</dd>
        </dl>
      </subsection>

      <dl class="dl-horizontal">
        <dt>Is a staff training session for dry cow/teat sealant insertion required? If YES, what date:</dt>
        <dd>{{ model.staff_drycow_training_date || '-' }}</dd>
      </dl>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'ThisSeasonDryOff',
  mixins: [mixin],
}
</script>
